(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    const applyOffToAll = () => {
      const tags = document.querySelectorAll(".sf__pcard-image .hc-sale-tag span");

      tags.forEach(tag => {
        const value = tag.textContent.trim();
        if (!tag.innerHTML.includes("OFF")) {   // evitar duplicados
          tag.innerHTML = `${value} <strong class="sale-off">OFF</strong>`;
        }
      });
    };

    // Corre cuando ya existe el DOM
    applyOffToAll();

    // Observa si Shopify agrega más products dinámicamente
    const observer = new MutationObserver(() => {
      applyOffToAll();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

})();
